import { onMounted } from 'vue';
import { logNoUa } from '../../utils/log';
import log from '../../utils/log';
import { onLCP, onINP, onCLS, onTTFB, onFCP } from 'web-vitals';
// 所有和性能监测的，都放在这个里面
// 检查跨域资源有问题，或者是br压缩的资源

function usePerformanceMetrics() {
  onMounted(() => {
    function handleLog(v) {
      if (v.rating !== 'good') {
        console.log('有登录性能问题', v);
        v.isNetWork = true;
        log(v);
      }
    }
    onCLS(handleLog);
    onLCP(handleLog);
    onINP(handleLog);
    onFCP(handleLog);
    onTTFB(handleLog);
    // 每个里面必用，这里是用来测量性能
    // const observer = new PerformanceObserver((list) => {
    //   const entries = list.getEntries();
    //   entries.forEach((entry) => {
    //     // 排除明确成功的请求（200/304）
    //     const isSuccess = entry.responseStatus === 200 || entry.responseStatus === 304;
    //     // 可能是内存缓存的请求（快速且无传输数据）
    //     const isLikelyMemoryCache = (
    //       entry.responseStatus === 0 &&
    //       entry.duration < 50
    //     );
    //     // 真实失败的判定条件
    //     const isRealFailure = (
    //       !isSuccess &&
    //       !isLikelyMemoryCache &&
    //       (
    //         (entry.encodedBodySize === 0 && entry.decodedBodySize === 0) ||
    //         entry.responseStatus >= 400 ||
    //         (entry.responseStatus === 0 && entry.duration > 1000)
    //       )
    //     );

    //     if (isRealFailure) {
    //       logNoUa({
    //         message: '前端资源加载失败',
    //         url: entry.name,
    //         type: entry.initiatorType,
    //         status: entry.responseStatus,
    //       });
    //     }
    //   });
    // });
    // observer.observe({ type: 'resource', buffered: true });

    const longTaskObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      for (const entry of entries) {
        if (entry.duration > 50) {
          logNoUa({
            message: '前端出现长任务',
            value: entry.duration,
          });
        }
      }
    });
    longTaskObserver.observe({ type: 'longtask', buffered: true });

    // 监测内存

    // 检测请求耗时
    const fetchObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      entries.forEach((entry) => {
        if (entry.entryType === 'resource' && entry.initiatorType === 'fetch') {
          if (entry.duration >= 2000) {
            log({
              type: 'fetch',
              isNetWork: true,
              message: '请求超时',
              url: entry.name,
            });
          }
        }
      });
    });

    // 指定要观察的性能条目类型
    fetchObserver.observe({ entryTypes: ['resource'] });

    // 检测错误
    window.onerror = function (message, source, lineno, colno, error) {
      console.error(
        `Error occurred: ${message} at ${source}:${lineno}:${colno}`
      );
      log({
        type: 'error',
        location: 'onerror',
        message: message,
        source: source,
        lineno: lineno,
        colno: colno,
        error: error,
      });
    };

    // window.addEventListener('unhandledrejection', function (event) {
    //   console.error('Unhandled promise rejection:', event.reason);
    //   log({
    //     type: 'error',
    //     location: 'unhandledrejection',
    //     event: event,
    //   });
    // });
  });
}

export default usePerformanceMetrics;
